import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export  function ConfirmDialog(props) {
  const open=props.open;
  const title=props.title;
  const message=props.message;
  const buttons=props.buttons;
  const handleClose=props.onClose;
  return (
    <div>      
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {buttons.map(button => (
               <Button key={button.name} onClick={button.callback}>{button.text}</Button>

            ))}
        </DialogActions>
      </Dialog>
    </div>
  );
}